module.exports = __webpack_public_path__ + "img/ok.a6b34453.svg";